<template>
	<div class="task" :class="{'task--failed': signal.status, 'task--done': !signal.status }">
		<div class="task__body">
			<div class="task__path" v-if="signal.signalItem !== ''">
				<div class="task__path-item">
					{{ signal.signalItem }}
				</div>
			</div>
			<a class="task__name" @click="openSignal">
				<HiddenText :text="signal.signalProblem" :limited="200" />
			</a>
		</div>
		<div class="task__footer">
			<div class="task__date">
				{{ $moment(signal.dateCreated).format('DD.MM.YYYY') }}
			</div>
		</div>
	</div>

  <PanelSignal ref="panelSignal" @createTask="()=>{ isCreate = true }" @close="() => { if(isCreate) { $emit('createTask'); } }" />

</template>

<script setup>
  import PanelSignal from '@/components/panels/PanelSignal.vue';
  import HiddenText from '@/components/ux/HiddenText.vue';
</script>

<script>
  	export default {
    	name: 'PageTrackerHouse',
      emits: ['createTask'],
    	props: ['signal', 'organization_id', 'house_id'],
			data: () => ({
				isCreate: false,
    	}),
    	computed: {
    	},
    	methods: {
	    	openSignal () {
	    		
	    		console.log('Открыть сигнал')

	    		this.$refs.panelSignal.show({
		        signal_id: this.signal.id,
		      	house_id: this.house_id,
		      	organization_id: this.organization_id,
		      });

	    	},
    	},
  	}
</script>

<style scoped>
	










	.task {
		padding: 15px;
		background-color: var(--cozh-white);
		border-radius: 8px;
	}
	.task:not(:last-child) {
		margin-bottom: 5px;
	}
	
	.task__header {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid var(--cozh-light-grey);
		padding-bottom: 10px;
	}
	.task__footer {
		padding-top: 10px;
    border-top: 1px solid var(--cozh-light-grey);
    display: flex;
    flex-direction: revert;
    align-items: center;
    justify-content: space-between;
	}


	.task__status {
		font-size: 12px;
		font-weight: 500;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;

	}
	.task__num {
		color: var(--cozh-grey);
		font-size: 12px;
		font-weight: 500;
	}
	.task__badge {
		height: 24px;
		width: 24px;
		border-radius: 50%;
		margin-right: 8px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
	.task__badge svg {
		width: 12px;
	}
	.task__body {
		margin-bottom: 15px;
	}
	.task__name {
		font-size: 14px;
		font-weight: 500;
		line-height: 1.2;
		display: flex;
	}
	.task__date {
		color: rgba(var(--cozh-black-code), .5);
 		font-size: 12px;
 		font-weight: 500;
	}



	.task__path {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: 8px;
	}
	.task__path-item {
		color: var(--cozh-grey);
 		font-size: 12px;
	 	font-weight: 500;
	 	max-width: 50%;
	 	text-overflow: ellipsis;
	 	overflow: hidden;
	 	white-space: nowrap;
	 	position: relative;
	}
	.task__path-item:not(:last-child) {
		padding-right: 23px;
	 	max-width: calc(50% + 20px);
	}
	.task__path-item:not(:last-child)::before {
		content: url('../../assets/img/check-right-grey.svg');
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
	}





	/* done  */
	.task--done .task__status {
		color: var(--cozh-blue);
	}
	.task--done .task__badge {
		background-color: rgba(233, 241, 244, 1);
	}
	.task--done .task__badge svg path {
		fill: var(--cozh-blue);
	}

	/* failed  */
	.task--failed .task__status {
		color: var(--cozh-red);
	}
	.task--failed .task__badge {
		background-color: rgba(var(--cozh-red-code), .12);
	}
	.task--failed .task__badge svg path {
		fill: var(--cozh-red);
	}



</style>